import { useEffect, useState, useMemo, useRef, } from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';

import { Form, Badge, } from 'react-bootstrap';
import { Notification, } from 'rsuite';

import api from '../../services/api';

import 'react-toastify/dist/ReactToastify.css';
import './styles.css';


const CorpoAlertabackup = ({ data }) => {
  const [obs, setObs] = useState(data.obs);
  // alertas antigos vêm sem a flag, e o padrão do backend é consumir o banco de horas
  const [consumesHourBank, setConsumesHourBank] = useState(
    null == data.consumes_hour_bank ? true : Boolean(data.consumes_hour_bank)
  );
  const isDirty = useRef(false);
  // o débito no banco de horas só acontece na criação do chamado, então depois
  // dela a flag vira apenas registro do que foi cobrado e não pode mais mudar
  const [hourBankLocked, setHourBankLocked] = useState(Boolean(data.ticket_id));
  const { field, bgColor, } = useMemo(() => {
    const ret = {
      field: 'Erro',
      bgColor: '',
    };

    if (data.size) {
      ret.field = data.size;
    } else if (data.files) {
      ret.field = data.files;
    } else if (data.disc_space) {
      ret.bgColor = 'rgba(255, 0, 0, 0.21)';
      ret.field = `${data.disc_space} %`;
    } else if (data.missing_backup) {
      ret.field = 'Backup não enviado';
      ret.bgColor = 'rgba(160, 160, 160, 0.21)';
    } else if (data.success) {
      ret.field = data.success;
    }

    return ret;
  }, [data]);



  const handleOnChange = (event) => {
    isDirty.current = true;
    setObs(event.target.value)
  }

  const handleHourBankChange = (event) => {
    isDirty.current = true;
    setConsumesHourBank(event.target.checked)
  }

  async function inserData() {
    if (isDirty.current && obs) {
      await api
        .post('/UpdateAlerts', {
          id: data.id,
          name_empresa: data.name_empresa,
          obs: obs,
          consumes_hour_bank: consumesHourBank,
        })
        .then((response) => {
          isDirty.current = false;

          // o alerta devolvido é a fonte da verdade da flag: o chamado pode já ter
          // sido aberto antes, e nesse caso o backend ignora o que foi enviado
          const updatedAlert = response.data && response.data.AlertaAlterado;
          if (updatedAlert) {
            setHourBankLocked(Boolean(updatedAlert.ticket_id));
            setConsumesHourBank(
              null == updatedAlert.consumes_hour_bank ? true : Boolean(updatedAlert.consumes_hour_bank)
            );
          }

          return Notification['success']({
            placement: 'bottomEnd',
            title: 'Alerta alterado',
            description: `Alerta da ${data.name_empresa}, HOST ${data.host} e Backup ${data.backup}, salvo com sucesso.`,
          })
        })
        .catch(() => {
          return Notification['error']({
            placement: 'bottomEnd',
            title: 'Erro ao alterar o alerta',
          })
        })
    }
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => inserData(), 1300)
    return () => clearTimeout(timeoutId)
  }, [obs, consumesHourBank]);


  return (
    <tbody>
      <tr style={{
          backgroundColor: bgColor,
        }}>
        <td className="Itens">
          {data.name_empresa}
        </td>
        <td className="Itens">
          {data.host}
        </td>
        <td className="Itens">
          {data.backup}
        </td>
        <td className="Itens">
          {data.success}
        </td>
        <td className="Itens">
          <Badge>
            {field}
          </Badge>
        </td>
        <td className="Itens">
          {moment(data.started_at).format('llll')}
        </td>
        <td>
          <Form.Control
            as="textarea"
            rows={5}
            value={obs}
            onChange={handleOnChange}
          />
          <Form.Check
            type="checkbox"
            className="HourBankCheck"
            id={`consumes-hour-bank-${data.id}`}
            label="Consumir banco de horas"
            checked={consumesHourBank}
            onChange={handleHourBankChange}
            disabled={hourBankLocked}
            title={
              hourBankLocked
                ? 'O chamado já foi aberto, o banco de horas não pode mais ser alterado por aqui.'
                : undefined
            }
          />
        </td>
      </tr>
    </tbody>
  );
}

export default CorpoAlertabackup;
